import {
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_WEB_LARGE,
} from 'helpers/BreakpointHelper';

export const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 0,
    carouselLimit: 4,
    posterLimit: 5,
    posterToScroll: 5,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 4,
    socialLinks: true,
    subtitleLines: 2,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    videoBackground: true,
  },
  [SITE_PLATFORM_WEB]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 0,
    carouselLimit: 3,
    descriptionLines: 5,
    posterLimit: 5,
    posterToScroll: 5,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    socialLinks: true,
    subtitleLines: 2,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: true,
  },
  [SITE_PLATFORM_TABLET]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 4,
    carouselLimit: 2,
    descriptionLines: 5,
    posterLimit: 3,
    posterToScroll: 3,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 2,
    socialLinks: false,
    subtitleLines: 2,
    tabsInAltHeader: true,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: false,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 3,
    carouselLimit: 2,
    descriptionLines: 5,
    posterLimit: 3,
    posterToScroll: 3,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.raw',
    showTileMetadataOnHover: false,
    slidesToScroll: 2,
    socialLinks: false,
    subtitleLines: 2,
    tabsInAltHeader: true,
    useScrollableDiv: true,
  },
};

export const FoxContentDensityBreakpoints = {
  [SITE_PLATFORM_WEB_LARGE]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 0,
    carouselLimit: 4,
    posterLimit: 6,
    posterToScroll: 6,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 4,
    socialLinks: true,
    subtitleLines: 2,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    videoBackground: true,
  },
  [SITE_PLATFORM_WEB]: {
    actionButtonsInHeader: false,
    actionButtonsInNav: true,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 0,
    carouselLimit: 4,
    descriptionLines: 5,
    posterLimit: 5,
    posterToScroll: 5,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logo.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 4,
    socialLinks: true,
    subtitleLines: 2,
    tabsInAltHeader: false,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: true,
  },
  [SITE_PLATFORM_TABLET]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: true,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 4,
    carouselLimit: 3,
    descriptionLines: 5,
    posterLimit: 4,
    posterToScroll: 4,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.raw',
    showTileMetadataOnHover: true,
    slidesToScroll: 3,
    socialLinks: false,
    subtitleLines: 2,
    tabsInAltHeader: true,
    useScrollableDiv: false,
    useSeriesLogo: true,
    videoBackground: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    actionButtonsInHeader: true,
    actionButtonsInNav: false,
    addCarouselPlaceholders: false,
    allowScrollLock: false,
    applyInlineBackground: true,
    backgroundImagePath: 'images.seriesDetail.raw',
    brandingTitleClampSize: 3,
    carouselLimit: 2,
    descriptionLines: 5,
    posterLimit: 3,
    posterToScroll: 3,
    renderAltHeader: false,
    roundArrows: true,
    showCarouselArrows: true,
    showLogoPath: 'images.logoCenter.raw',
    showTileMetadataOnHover: false,
    slidesToScroll: 2,
    socialLinks: false,
    subtitleLines: 1,
    tabsInAltHeader: true,
    useScrollableDiv: true,
  },
};
